import React from 'react'
import { l } from '@manychat/manyui'

import { useAppSelector } from 'reduxTyped'
import { SidebarHeader } from 'apps/aiAutomation/components/SidebarHeader'
import { AiAutomationToneOfVoiceSelectors } from 'apps/aiAutomation/store/toneOfVoice'
import { AiAutomationTovState } from 'shared/api/requests/aiToneOfVoice/schemas'

import { PreparingDataLoader } from './components/PreparingDataLoader/'
import { Questionnaire } from './components/Questionnaire'
import { SuccessTuning } from './components/SuccessTuning'

import cm from './styles.module.css'

export const TovSetup = () => {
  const tovState = useAppSelector(AiAutomationToneOfVoiceSelectors.getTovState)
  const samples = useAppSelector(AiAutomationToneOfVoiceSelectors.getSamples)
  const isLoading =
    !tovState ||
    tovState === AiAutomationTovState.CAPTURING_DATA ||
    (tovState === AiAutomationTovState.GENERATING_SAMPLES && !samples.length)

  const showQuestionnaire = Boolean(
    tovState === AiAutomationTovState.WAITING_USER_REACTION ||
      (tovState === AiAutomationTovState.GENERATING_SAMPLES && samples.length) ||
      (tovState === AiAutomationTovState.FINISHED && samples.length),
  )

  return (
    <section className={cm.wrapper}>
      <SidebarHeader
        title={
          tovState === AiAutomationTovState.FINISHED
            ? l.translate('AI Comments')
            : l.translate('Set AI’s tone')
        }
      />

      <div className="o-auto p-y-md p-x">
        {isLoading && (
          <PreparingDataLoader
            message={l.translate('AI is capturing your tone from Instagram...')}
          />
        )}

        {showQuestionnaire && <Questionnaire />}

        {tovState === AiAutomationTovState.FINISHED && <SuccessTuning />}
      </div>
    </section>
  )
}
